import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, X } from "lucide-react";
import { useApi, inr } from "@/lib/api";

const KEY = "isc_income_seen";

export const TodayIncome = () => {
  const api = useApi();
  const [data, setData] = useState(null);
  useEffect(() => {
    api("get", "/me/today-income").then((d) => { if (d.amount > 0 && localStorage.getItem(KEY) !== d.date) setData(d); }).catch(() => {});
  }, [api]);
  const dismiss = () => { localStorage.setItem(KEY, data.date); setData(null); };
  return (
    <AnimatePresence>
      {data && (
        <motion.div initial={{ opacity: 0, y: -12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }}
          className="relative mb-8 flex items-center gap-4 overflow-hidden rounded-2xl border border-emerald-500/40 bg-gradient-to-r from-emerald-500/15 to-transparent p-5" data-testid="today-income-alert">
          <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-emerald-500/20"><Sparkles className="h-6 w-6 text-emerald-400" /></span>
          <div className="min-w-0 flex-1">
            <p className="font-display text-xl font-bold text-white"><span className="text-emerald-400" data-testid="today-income-amount">{inr(data.amount)}</span> credited today</p>
            <p className="text-sm text-slate-400">Daily income from {data.plans} plan{data.plans > 1 ? "s" : ""} has been added to your wallet. <Link to="/dashboard/earnings" className="text-emerald-400 hover:underline" data-testid="today-income-link">View earnings</Link></p>
          </div>
          <button onClick={dismiss} className="rounded-full p-1.5 text-slate-400 hover:bg-white/10 hover:text-white" data-testid="today-income-dismiss"><X className="h-4 w-4" /></button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
